import React from "react";
import EnquiryForm from "@/components/EnquiryForm";
import { Wrench, Headphones, Clock, MapPin } from "lucide-react";

export default function InstallSupport() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="support-page">
      <div className="max-w-3xl">
        <div className="eyebrow">Installation & support</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">Professional installation, dependable support</h1>
        <p className="mt-4 text-slate-600">Our certified technicians install and configure GPS devices at your location or nearest partner workshop across Rajasthan and pan-India.</p>
      </div>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { icon: Wrench, t: "Certified Installers", d: "Trained technicians for cars, bikes, trucks and buses." },
          { icon: MapPin, t: "Pan-India Reach", d: "Installation and service across major Indian cities." },
          { icon: Clock, t: "Fast Turnaround", d: "Most installations completed in 45-60 minutes." },
          { icon: Headphones, t: "7-Day Support", d: "Phone, WhatsApp and email support in Hindi & English." },
        ].map((it) => (
          <div key={it.t} className="p-6 rounded-2xl border border-slate-200 bg-white">
            <div className="w-11 h-11 rounded-xl bg-[#FF6D00]/10 text-[#FF6D00] flex items-center justify-center"><it.icon className="w-5 h-5" /></div>
            <h3 className="font-heading font-semibold text-[#0A192F] mt-4">{it.t}</h3>
            <p className="text-sm text-slate-600 mt-1.5">{it.d}</p>
          </div>
        ))}
      </div>
      <div className="mt-16 grid lg:grid-cols-2 gap-8">
        <div className="rounded-2xl bg-[#0A192F] text-white p-8">
          <h2 className="font-heading text-2xl font-bold">Book an installation slot</h2>
          <p className="text-slate-300 mt-2 text-sm">Share your vehicle details and preferred date — we'll confirm a time.</p>
          <ul className="mt-6 space-y-2 text-sm text-slate-300 list-disc list-inside">
            <li>On-site installation available in most cities</li>
            <li>Workshop / drop-in slots also supported</li>
            <li>Post-install training on the mobile app</li>
          </ul>
        </div>
        <EnquiryForm title="Schedule Installation" subtitle="Our operations team confirms within a few hours." enquiry_type="installation" testIdPrefix="install-enquiry" />
      </div>
    </div>
  );
}
